import { buildV2InstrumentUpdateBody, instrumentV2Urls } from './instrumentV2Api'
import {
  applyDefaultV3Schedule,
  getDefaultScheduleV3,
  isV3ScheduleShape,
} from 'features/schedulingEngine/constants/defaultSchedule'

export const INSTRUMENT_V3_BASE = studyID => `/control/v3/studies/${studyID}/instruments`

/** V3 instrument routes when scheduling_engine is on (GOLD-12357). */
export const instrumentV3Urls = {
  create: studyID => INSTRUMENT_V3_BASE(studyID),
  one: (studyID, instrumentID, query = '') =>
    `${INSTRUMENT_V3_BASE(studyID)}/${instrumentID}${query || ''}`,
  deploy: (studyID, instrumentID, query = '') =>
    `${INSTRUMENT_V3_BASE(studyID)}/${instrumentID}/deploy${query || ''}`,
}

export const useV3InstrumentTransport = hasSchedulingEngine => !!hasSchedulingEngine

export const getInstrumentCreateUrl = (studyID, hasSchedulingEngine = false) =>
  useV3InstrumentTransport(hasSchedulingEngine)
    ? instrumentV3Urls.create(studyID)
    : instrumentV2Urls.create(studyID)

export const getInstrumentUpdateUrl = (studyID, instrumentID, hasSchedulingEngine = false, query = '') =>
  useV3InstrumentTransport(hasSchedulingEngine)
    ? instrumentV3Urls.one(studyID, instrumentID, query)
    : instrumentV2Urls.one(studyID, instrumentID, query)

/**
 * Deploy: V3 when scheduling_engine is on, otherwise legacy V2 deploy.
 * @see https://humanproject.atlassian.net/wiki/spaces/ETD/pages/3726180353
 */
export const getInstrumentDeployUrl = (
  studyID,
  instrumentID,
  query = '',
  hasSchedulingEngine = false,
) =>
  hasSchedulingEngine
    ? instrumentV3Urls.deploy(studyID, instrumentID, query)
    : instrumentV2Urls.deploy(studyID, instrumentID, query)

/** Schedule/metadata body shape; V3 handlers accept the same PUT body as V2. */
export const buildV3InstrumentUpdateBody = buildV2InstrumentUpdateBody

export { applyDefaultV3Schedule, getDefaultScheduleV3, isV3ScheduleShape }
